// Holiday rental types: the stored values (Appartement, Maison, Commercial) never change; only their
// display uses the labels of the vacation publication form. Case-insensitive ("commercial" from older
// forms included). An unknown value has no key: callers show it as is, nothing is invented.
const VACATION_TYPE_KEYS = { appartement: "entirePlace", maison: "oneRoom", commercial: "sharedRoom" };

export const vacationTypeKey = (value) => VACATION_TYPE_KEYS[String(value ?? "").trim().toLowerCase()] || null;

export function vacationTypeLabel(t, value) {
  const key = vacationTypeKey(value);
  return key ? t(key) : String(value ?? "").trim();
}
